import { useQuery, gql } from '@apollo/client';

type UseNotificationResult = {
  notification: string;
  loading: boolean;
  error?: any;
};

const GET_ENTRY_YEAR_NOTIFICATION = gql`
  query GetEntryYearNotification($entryYear: String!) {
    entryYearInformation(entryYear: $entryYear) {
      notification
      welcomeLetter
      id
      displayText
    }
  }
`;

export const useNotification = (entryYear: string): UseNotificationResult => {
  const { data, error, loading } = useQuery(GET_ENTRY_YEAR_NOTIFICATION, {
    variables: { entryYear },
  });

  return {
    notification: data?.entryYearInformation?.notification ?? '',
    loading,
    error,
  };
};
